"use strict";
exports.__esModule = true;
exports.TextAlign = void 0;
var core_1 = require("@tiptap/core");
exports.TextAlign = core_1.Extension.create({
    name: "textAlign",
    defaultOptions: {
        types: [],
        alignments: ["left", "center", "right", "justify"],
        defaultAlignment: "left"
    },
    addGlobalAttributes: function () {
        var _this = this;
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        "default": this.options.defaultAlignment,
                        parseHTML: function (element) { return ({
                            textAlign: element.style.textAlign || _this.options.defaultAlignment
                        }); },
                        renderHTML: function (attributes) {
                            return {
                                style: "text-align: " + attributes.textAlign + ";"
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands: function () {
        var _this = this;
        return {
            setTextAlign: function (alignment) {
                return function (_a) {
                    var commands = _a.commands;
                    if (!_this.options.alignments.includes(alignment)) {
                        return false;
                    }
                    return _this.options.types.every(function (type) { return commands.updateAttributes(type, { textAlign: alignment }); });
                };
            },
            unsetTextAlign: function () {
                return function (_a) {
                    var commands = _a.commands;
                    return _this.options.types.every(function (type) { return commands.resetAttributes(type, "textAlign"); });
                };
            }
        };
    },
    addKeyboardShortcuts: function () {
        var _this = this;
        return {
            "Mod-Shift-l": function () { return _this.editor.commands.setTextAlign("left"); },
            "Mod-Shift-e": function () { return _this.editor.commands.setTextAlign("center"); },
            "Mod-Shift-r": function () { return _this.editor.commands.setTextAlign("right"); },
            "Mod-Shift-j": function () { return _this.editor.commands.setTextAlign("justify"); }
        };
    }
});
